// extracted by mini-css-extract-plugin
export var arrow_icon = "index-module--arrow_icon--0b1a8";
export var btn_label = "index-module--btn_label--7332a";
export var btn_link = "index-module--btn_link--3714b";
export var close_btn = "index-module--close_btn--ea275";
export var close_icon = "index-module--close_icon--e04af";
export var content_wrapper = "index-module--content_wrapper--42cdf";
export var inner = "index-module--inner--8aaf3";
export var title = "index-module--title--fba85";
export var wrapper = "index-module--wrapper--5e383";